import { formatPrice } from '@ynap/intl-formatters';

export default function getShippingPrice(originalPrice, adjustedPrice, currency, messages, locale) {
    const original = calculatePrice(originalPrice);
    const adjusted = calculatePrice(adjustedPrice);

    return {
        originalShippingPrice: originalPrice.amount !== adjustedPrice.amount ? formatPrice(original, currency.label, locale.id) : undefined,
        finalShippingPrice: adjustedPrice.amount > 0 ? formatPrice(adjusted, currency.label, locale.id) : messages?.totals.zeroShippingPrice(),
        rawShippingPrice: originalPrice.amount !== adjustedPrice.amount ? adjusted : original,
    };
}

function calculatePrice(price) {
    return price.amount / price.divisor;
}
